import { render, staticRenderFns } from "./MasonryTest.vue?vue&type=template&id=189a16e4&"
import script from "./MasonryTest.vue?vue&type=script&lang=js&"
export * from "./MasonryTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports